/**
 * Make an object from an array of keys.
 */
export function makeRecord(keys, valueFn) {
  const r = {};
  for (const k of keys) {
    r[k] = valueFn(k);
  }
  return r;
}